import { createContext, useContext, type ReactNode } from 'react';
import type { KpiSelectionResult } from '../utils/kpiSelectionUtils';

export interface KpiContextValue {
  kpiSelection: KpiSelectionResult;
  isIncludeExcitementToggleChecked: boolean;
  isShowGroundArticlesToggleChecked: boolean;
}

const KpiContext = createContext<KpiContextValue | null>(null);

export function KpiContextProvider({
  children,
  value,
}: Readonly<{ children: ReactNode; value: KpiContextValue }>) {
  return <KpiContext.Provider value={value}>{children}</KpiContext.Provider>;
}

export function useKpiContext(): KpiContextValue {
  const ctx = useContext(KpiContext);
  if (!ctx) throw new Error('useKpiContext must be used within KpiContextProvider');
  return ctx;
}
